export const APP_NAME = 'RAJIDA Drive'; 